module.exports = __webpack_public_path__ + "static/img/content_bg_ar.ed607ba7.webp";